import React, { FC } from 'react';
import {
  FormControl,
  Grid,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { connect, FormikProps } from 'formik';
import { compose } from 'recompose';

import { Content, ContentUrlParamOptions } from 'api';
import { CustomSVG } from 'components';

interface IProps {
  index: number;
  paramOptions: ContentUrlParamOptions;
  onChange: (index: number, value: unknown) => void;
}

interface IPropsEnhanced extends IProps, WithStyles<typeof styles> {
  formik: FormikProps<Content>;
}

const styles = (theme: Theme) =>
  createStyles({
    paper: {
      padding: `${theme.spacing(1)}px ${theme.spacing(2)}px ${theme.spacing(2)}px`,
    },
    titleCell: {
      width: 100,
    },
    key: {
      fontSize: theme.typography.pxToRem(16),
    },
  });

const enhancers = compose<IPropsEnhanced, IProps>(connect, withStyles(styles));

const URLTracking: FC<IPropsEnhanced> = ({ classes, formik, index, paramOptions, onChange }) => {
  const { t } = useTranslation();
  const { values } = formik;
  const { options } = paramOptions;

  function renderKeyValue() {
    return (
      <Table padding="none">
        <TableBody>
          <TableRow>
            <TableCell className={classes.titleCell}>
              <Typography variant="subtitle2">{t('posting:key')}</Typography>
            </TableCell>
            <TableCell>
              <Typography className={classes.key}>{paramOptions.key}</Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Typography variant="subtitle2">{t('posting:value')}</Typography>
            </TableCell>
            <TableCell>{renderSelect()}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    );
  }

  function renderSelect() {
    const { url_param_values } = values;
    const value = (url_param_values[index] && url_param_values[index].value) || options[0];

    return (
      <Select fullWidth value={value} onChange={event => onChange(index, event.target.value)}>
        {options.map(valueOption => (
          <MenuItem key={valueOption} value={valueOption}>
            {valueOption}
          </MenuItem>
        ))}
      </Select>
    );
  }

  return (
    <FormControl margin="normal" fullWidth>
      <Grid container spacing={2} alignItems="center">
        <Grid item>
          <CustomSVG color="primary" name="track" />
        </Grid>
        <Grid item xs>
          <Paper className={classes.paper}>{renderKeyValue()}</Paper>
        </Grid>
      </Grid>
    </FormControl>
  );
};

export default enhancers(URLTracking);
